module.exports = __webpack_public_path__ + "static/media/997649.3c6edaf6.jpg";